import { createSlice } from '@reduxjs/toolkit';
import { getFeatureDetails, getFeaturesListByTenant } from './featureDetailsAction';

export const featureDetailSlice = createSlice({
  name: 'featureDetails',
  initialState: {
    loading: false,
    data: {},
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeatureDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFeatureDetails.fulfilled, (state, { payload }) => {      
    console.log('payload :', payload);
      state.loading = false;
      state.data = payload.data;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(getFeatureDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});

export const featureListByTenant = createSlice({
  name: 'featureListByTenant',
  initialState: {
    loading: false,
    data: {},
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeaturesListByTenant.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFeaturesListByTenant.fulfilled, (state, { payload }) => {      
      state.loading = false;
      state.data = payload.data;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(getFeaturesListByTenant.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});
